const C_KEY_TOKEN = "C_KEY_TOKEN";
const C_KEY_REFRESH_TOKEN = "C_KEY_REFRESH_TOKEN";
export const AUTH_KEY_TOKEN = "gg-auth-token";

export const saveToken = (data) => {
  const { token, refresh_token } = data;
  setCookie(C_KEY_TOKEN, token, 30);
  setCookie(C_KEY_REFRESH_TOKEN, refresh_token, 30);
};

export const removeToken = () => {
  setCookie(C_KEY_TOKEN, "", 0);
  setCookie(C_KEY_REFRESH_TOKEN, "", 0);
};

export const removeTokenByKey = (key) => {
  setCookie(key, "", 0);
};

export function getAccessToken(key = C_KEY_TOKEN) {
  return getCookie(key);
}

export function getRefreshToken() {
  return getCookie(C_KEY_REFRESH_TOKEN);
}

const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

function hashToNumber(str) {
  let hash = 0;

  // Simple hash algorithm (you can replace this with a more complex one if needed)
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to a 32-bit integer
  }

  // Ensure the number is positive by taking the absolute value
  return Math.abs(hash);
}

export function hashToBgColor(hashId) {
  // Ensure the hash is at least 6 characters long
  if (!hashId) {
    return null;
  }

  const number = hashToNumber(hashId) + 30;
  return `#${(number & 0xffffff).toString(16).padStart(6, "0")}`;
}

export function generateHashId() {
  return [...Array(24)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join("");
}

export const pluralize = (word, count, inclusive) => {
  if (!word) return "";

  const newWord = count === 1 ? word : `${word}s`;

  if (inclusive) return `${count} ${newWord}`;

  return newWord;
};
